/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import TOC from '@ember/component/template-only';
import type { TWorkshopType } from 'volta/models/types/workshop.d';
import type { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';

export interface ISkusWorkshopFilterDefinitionArgs {
  skuId?: string;
  warehouseId?: string;
  scenarioId?: string;
  workshopTypes?: TWorkshopType[];
  noMatchesMessage?: string;
  placeholder?: string;
  renderInPlace?: boolean;
  beforeQuery?: (query: IJsonApiQuery) => IJsonApiQuery;
}

const FiltersSkusWorkshopFilterComponent = TOC<ISkusWorkshopFilterDefinitionArgs>();

export default FiltersSkusWorkshopFilterComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::SkusWorkshopFilter': typeof FiltersSkusWorkshopFilterComponent;
    'filters/skus-workshop-filter': typeof FiltersSkusWorkshopFilterComponent;
  }
}
